// Hover Highlight folgt den Links

const triggers = document.querySelectorAll(".main--nav-item");
const highlight = document.getElementById("highlight");
const mainNav = document.querySelector(".main--nav");
const mainNavUl = document.querySelector(".main--nav-ul");
const burger = document.getElementById("burger");
const mainNavListItem = document.querySelectorAll('.main--nav-listItem')

const closeNav = () => { 
  document.querySelector('html').classList.remove('mobile-nav')
}

triggers.forEach(t => { 
  t.addEventListener('click', closeNav)
})

function highlightLink() {
  const linkCoords = this.getBoundingClientRect();
  highlight.style.opacity = 1;
  highlight.style.width = `${linkCoords.width}px`;
  highlight.style.height = `${linkCoords.height}px`;
  highlight.style.transform = `
          translate(${linkCoords.left}px, ${linkCoords.top}px)`;
}

function leaveHighlight() {
  highlight.style.opacity = 0;
}

const setActiveState = () => {
  document.getElementsByTagName("html")[0].classList.toggle("mobile-nav");
};

triggers.forEach(a => a.addEventListener("mouseenter", highlightLink));
mainNavUl.addEventListener("mouseleave", leaveHighlight);
burger.addEventListener("click", setActiveState);
window.addEventListener("resize", e => {
  if (window.innerWidth > 1200) {
    document.getElementsByTagName("html")[0].classList.remove("mobile-nav");
    document
      .querySelector(".produkte--content-buttons")
      .classList.remove("active");
  }
});

const navAnchorHighlight = () => { 
  const scrollTop = window.scrollY;
  mainNavListItem.forEach(item => { 
    let link = item.querySelector('a').href.split('/')[3]
    

    if (link.indexOf('#') > -1) { 
      link = link.replace('#', '')
      const target = document.getElementById(link)
      const height = target.clientHeight
      let itemPosition = target.getBoundingClientRect()
      let itemOffset = itemPosition.top
      if (target !== null) { 
        if (itemOffset < window.innerHeight / 2 && itemOffset > height * -1) {
          item.classList.add('active-anchor')
        } else { 
          item.classList.remove('active-anchor')
        }
        
      }

    }
    

  })
}

if (document.querySelector('.home')) { 
  navAnchorHighlight()
  window.addEventListener('resize', navAnchorHighlight)
  window.addEventListener('scroll', navAnchorHighlight)
}



